import Icon from '../../components/Icon.vue'

Icon.register({"brands/quora":{"width":448,"height":512,"paths":[{"d":"M440.5 386.7H411.2C409.7 400.2 400.7 417.5 378.2 417.5 357.7 417.5 342.9 403.3 328.7 381.7 372.9 347.5 403.4 294.2 403.4 228.7 403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7 7.3 362.8 138.6 450.3 256.3 417.7 276 451.3 302 480 351.5 480 433.3 480 442.3 404.7 440.5 386.7zM297 329.2C277.5 300 253.3 277 205.5 277 175 277 151.2 287 136.5 299.8L148.7 324.1C154.9 321.1 161.7 320.1 168.5 320.1 204 320.1 222.2 350.9 237.7 381.4 227.7 384.4 217 385.6 205 385.6 130 385.6 97.5 332.6 97.5 228.9 97.5 124.5 130 71 205 71 281.2 71 313.7 124.5 313.7 228.7 313.8 270.5 308.3 304.3 297 329.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/quora.js
// module id = wjYc
// module chunks = 0